import Base               from './components/Base'
import BatiFid            from './components/BatiFid'
import Dematerialisation  from './components/Dematerialisation'
import Loyalty            from './components/Loyalty'
import LoyaltyV3          from './components/LoyaltyV3'
import Lustucru           from './components/Lustucru'

const AllPublicMethods =
  Lustucru(
    LoyaltyV3(
      Loyalty(
        Dematerialisation(
          BatiFid(
            Base
          )
        )
      )
    )
  )

export default AllPublicMethods
